import basics from './basics';
import data from './data';
import tagboard from './tagboard';
import partners from './partners';

export default {
  basics,
  data,
  tagboard,
  partners,
};
